export const bookMeta = {
  title: 'Outdooring (Aba-Dinto)',
  subtitle: 'A Family Guide to Akan Day Names, Heritage, and Cultural Identity',
  author: 'Afia, aka Mama Africa',
  year: 2026,
};

export const bookSections = [
  {
    id: 'title',
    label: 'Title Page',
    roman: 'i',
    content: [
      { type: 'title', text: 'Outdooring (Aba-Dinto)' },
      { type: 'subtitle', text: 'A Family Guide to Akan Day Names, Heritage, and Cultural Identity' },
      { type: 'author', text: 'By Afia, aka Mama Africa' },
    ],
  },
  {
    id: 'copyright',
    label: 'Copyright',
    roman: 'ii',
    content: [
      { type: 'heading', text: 'Copyright' },
      { type: 'body', text: 'Copyright ©️ 2026 Afia, aka Mama Africa\nAll rights reserved.' },
      { type: 'body', text: 'No part of this publication may be reproduced, distributed, or transmitted in any form or by any means, including photocopying, recording, or other electronic or mechanical methods, without prior written permission of the author, except in the case of brief quotations embodied in reviews and certain other noncommercial uses permitted by copyright law.' },
      { type: 'body', text: 'This book is a cultural and educational guide intended to preserve, teach, and celebrate the Akan tradition of Outdooring (Aba-Dinto) and day-name customs in Ghana.' },
      { type: 'body', text: 'Published independently through Amazon KDP.\nISBN: [Insert if available]\nPrinted in the United States of America' },
    ],
  },
  {
    id: 'dedication',
    label: 'Dedication',
    roman: 'iii',
    content: [
      { type: 'heading', text: 'Dedication' },
      { type: 'dedication', text: 'Dedicated to my daughter, Ariel' },
      { type: 'body', text: 'Thank you for being my stylist, my coach, and an encouraging and supportive force in my world. Your love, guidance, and belief in me have meant more than words can fully express.' },
      { type: 'body', text: 'This book is dedicated to you with love and gratitude.' },
    ],
  },
  {
    id: 'foreword',
    label: 'Foreword',
    roman: 'iv',
    content: [
      { type: 'heading', text: 'Foreword' },
      { type: 'body', text: 'In many African societies, a name is never just a name. It carries memory, identity, ancestry, responsibility, and spirit. Among the Akan people of Ghana, this truth is beautifully expressed through the tradition of Outdooring (Aba-Dinto), the formal naming and public presentation of a child on the eighth day after birth.' },
      { type: 'body', text: 'This ceremony is more than a family custom. It is a sacred welcome. It is a public declaration that a child has arrived, belongs, and is now part of a lineage, a people, and a living heritage. Through this act, the child is introduced not only to relatives and elders, but also to the moral and cultural world of the community.' },
      { type: 'image', src: '/images/name ceremony.webp', alt: 'Akan outdooring and naming gathering', caption: 'Community and family gather for the naming and presentation of a child.' },
      { type: 'image', src: '/images/naming ceremony group picture(kwame and Ama).webp', alt: 'Kwame and Ama at their naming ceremony', caption: 'Kwame and Ama — day-born names and their community at the outdooring.' },
      { type: 'body', text: 'This book offers more than information. It offers restoration.' },
      { type: 'body', text: 'For children, it provides a simple and meaningful introduction to Akan day names and the significance of birth identity. For parents and elders, it serves as a teaching tool to help pass on tradition. For readers in the diaspora or anyone separated from their cultural roots, it opens a doorway back to memory, belonging, and self-discovery.' },
      { type: 'body', text: 'There is great value in knowing the customs that shaped our ancestors. There is also great healing in reclaiming what has been forgotten or interrupted. By learning the meaning of Outdooring (Aba-Dinto), readers may come to understand that even when traditions are delayed, they are not lost forever.' },
      { type: 'body', text: 'May this book educate, inspire, and encourage many to rediscover the beauty of Akan identity through naming, family, and cultural continuity.' },
    ],
  },
  {
    id: 'preface',
    label: 'Preface',
    roman: 'v',
    content: [
      { type: 'heading', text: 'Preface' },
      { type: 'body', text: 'This book was written for children, parents, grandparents, teachers, students, and all who wish to reconnect with Ghanaian culture through one of its most cherished traditions: Outdooring (Aba-Dinto).' },
      { type: 'body', text: 'Among the Akan people, the naming of a child is a deeply meaningful event. It is the moment when a baby is formally welcomed into the family and introduced to the community. It is also the time when the child receives a first name based on the day of the week on which he or she was born. This day name is often understood as a kradin, a soul name or spiritual birth name.' },
      { type: 'body', text: 'For generations, this tradition has helped preserve identity and family memory. It has reminded people that every child enters the world with meaning, place, and connection.' },
      { type: 'body', text: 'Yet many people today have grown up far removed from these customs. Some were never taught their Akan day name. Some never experienced a formal naming ceremony. Others know very little about their ancestry because of migration, time, or cultural separation. This book was created with them in mind.' },
      { type: 'body', text: 'The goal of this work is simple: to teach clearly, preserve lovingly, and inspire proudly. It is also to remind readers that it is not too late to learn. Anyone with sincere interest can begin to discover their day name, teach it to their children, and reintroduce this beautiful custom into family life.' },
      { type: 'body', text: 'May these pages help restore curiosity, identity, and pride in our African roots.' },
    ],
  },
  {
    id: 'toc',
    label: 'Table of Contents',
    roman: 'vi',
    content: [
      { type: 'heading', text: 'Table of Contents' },
      { type: 'toc', items: [
        { label: 'Dedication', page: 'iii' },
        { label: 'Foreword', page: 'iv' },
        { label: 'Preface', page: 'v' },
        { label: 'Chapter 1: What Is Outdooring (Aba-Dinto)?', page: '1' },
        { label: 'Chapter 2: Why the Ceremony Takes Place on the Eighth Day', page: '3' },
        { label: 'Chapter 3: The Akan Day-Name System', page: '5' },
        { label: 'Chapter 4: Program Outline for Outdooring (Aba-Dinto)', page: '7' },
        { label: 'Chapter 5: How the Ceremony Is Performed', page: '9' },
        { label: 'Chapter 6: Teaching the Next Generation', page: '11' },
        { label: 'Chapter 7: It Is Not Too Late', page: '13' },
        { label: 'Author Bio', page: '15' },
        { label: 'Back Cover Description', page: '16' },
      ]},
    ],
  },
  {
    id: 'ch1',
    label: 'Chapter 1',
    page: '1',
    chapterTitle: 'What Is Outdooring (Aba-Dinto)?',
    content: [
      { type: 'chapter', number: 1, text: 'What Is Outdooring (Aba-Dinto)?' },
      { type: 'body', text: 'In Ghanaian culture, it is customary to formally name each child born into a family. This naming is a special way of acknowledging, honoring, and welcoming the newborn.' },
      { type: 'body', text: 'Among the Akan people, this ceremony is called Outdooring (Aba-Dinto). It is the traditional naming ceremony in which a baby is brought out to meet the extended family and the community for the first time.' },
      { type: 'image', src: '/images/name ceremony1.webp', alt: 'Outdooring naming ceremony', caption: 'The eighth-day welcome: presentation, blessing, and day name.' },
      { type: 'image', src: '/images/naming ceremony white t shirt day borns .webp', alt: 'Day borns in white shirts at naming ceremony', caption: 'Family dressed in day-born white shirts — wearing heritage to the outdooring.' },
      { type: 'body', text: 'Traditionally, the ceremony takes place on the eighth day after birth. Parents keep the baby indoors during the first week of life, protecting the child from public view and from harmful spiritual influences. On the eighth day, the child is formally presented and named.' },
      { type: 'body', text: 'In earlier times, our ancestors did not rely on the modern Western calendar. Instead, they counted the days of the week in cycles. Thus, a child born on Sunday would be named on the following Sunday, which would be counted as the eighth day.' },
      { type: 'body', text: 'The child receives a first name according to the day of the week on which he or she was born. This first name becomes the child\'s kradin, or soul name. It is often followed by a family name honoring a grandparent or ancestor, and then by the father\'s surname.' },
      { type: 'body', text: 'Outdooring (Aba-Dinto) is therefore not simply a naming event. It is a formal welcome into family, lineage, and community.' },
    ],
  },
  {
    id: 'ch2',
    label: 'Chapter 2',
    page: '3',
    chapterTitle: 'Why the Ceremony Takes Place on the Eighth Day',
    content: [
      { type: 'chapter', number: 2, text: 'Why the Ceremony Takes Place on the Eighth Day' },
      { type: 'body', text: 'Among the Akan, the waiting period before Outdooring (Aba-Dinto) carries deep spiritual and cultural meaning.' },
      { type: 'body', text: 'The seven-day waiting period helps ensure that the child has truly come to stay on earth, known as Asase Yaa, and will not prematurely return to Asamando, the abode of the ancestors.' },
      { type: 'body', text: 'Until the eighth day, the infant is regarded as a newcomer, a visitor, or ɔhɔho among the living. For this reason, the naming and public presentation do not happen immediately after birth.' },
      { type: 'quote', text: 'Wo aba a tena ase.\n"Now that you have come, stay with us."' },
      { type: 'body', text: 'This blessing is a wish for health, long life, peace, and rootedness in the family.' },
      { type: 'body', text: 'The eighth day is not only practical. It is symbolic. It marks the moment when the child is publicly embraced as a full member of the household and community.' },
    ],
  },
  {
    id: 'ch3',
    label: 'Chapter 3',
    page: '5',
    chapterTitle: 'The Akan Day-Name System',
    content: [
      { type: 'chapter', number: 3, text: 'The Akan Day-Name System' },
      { type: 'body', text: 'The Akan naming system gives a child a first name based on the day of the week on which the child is born. These names are gender-specific, with distinct names for girls and boys.' },
      { type: 'table', headers: ['Day of the Week', 'Girls\' Names', 'Boys\' Names'], rows: [
        ['Monday', 'Adwoa', 'Kwadwo, Kojo, Kudjo, Jojo'],
        ['Tuesday', 'Abena', 'Kwabena, Cobby, Kobby'],
        ['Wednesday', 'Akua, Ekua, Kuukua', 'Kwaku, Kweku, Owuraku'],
        ['Thursday', 'Yaa, Yaa-Yaa', 'Yaw'],
        ['Friday', 'Afia, Afua, Effia', 'Kofi, Fiifi'],
        ['Saturday', 'Ama, Amma', 'Kwame'],
        ['Sunday', 'Akosua, Akose, Esi', 'Kwasi, Akwasi, Kwesi'],
      ]},
      { type: 'subheading', text: 'Examples' },
      { type: 'list', items: [
        'Friday-born girl: Afia, Afua, or Effia',
        'Friday-born boy: Kofi or Fiifi',
        'Sunday-born girl: Akosua',
        'Sunday-born boy: Kwasi, Akwasi, or Kwesi',
      ]},
      { type: 'body', text: 'These names immediately tell others the day on which the child was born and whether the child is male or female.' },
    ],
  },
  {
    id: 'ch4',
    label: 'Chapter 4',
    page: '7',
    chapterTitle: 'Program Outline for Outdooring (Aba-Dinto)',
    content: [
      { type: 'chapter', number: 4, text: 'Program Outline for Outdooring (Aba-Dinto)' },
      { type: 'body', text: 'The following simple outline shows how a traditional Outdooring (Aba-Dinto) ceremony may take place.' },
      { type: 'image', src: '/images/name ceremony2.webp', alt: 'Celebration at an outdooring', caption: 'Food, elders, and joy mark the day the child meets the wider family.' },
      { type: 'image', src: '/images/ama and kwame t shirt under naming ceremony.webp', alt: 'Ama and Kwame in day-born shirts at the naming ceremony', caption: 'Ama and Kwame — proudly wearing their day names at the outdooring celebration.' },
      { type: 'table', headers: ['Time', 'Activity'], rows: [
        ['5:00–6:00 a.m.', 'Close relatives and friends of the mother begin food preparation'],
        ['Early morning', 'The mother and baby are dressed and made ready for presentation'],
        ['Early morning', 'Two respected elders from the father\'s family go to bring the mother and child'],
        ['Opening', 'Family gathers and guests begin assembling'],
        ['Opening prayer and libation', 'An elder offers prayer and pours libation, announcing the purpose of the gathering'],
        ['8:00–9:00 a.m.', 'Guests continue to arrive'],
        ['Main ceremony', 'The baby is formally presented and named'],
        ['Public response', 'The baby\'s name is announced to the family and community'],
        ['Celebration', 'Food, refreshments, music, and dancing begin'],
        ['Gift giving', 'Guests offer presents and cash gifts to the baby and mother'],
        ['Closing prayer', 'A family elder, pastor, or respected community ally offers the closing prayer'],
        ['Afterward', 'Celebration continues with dancing and fellowship'],
      ]},
    ],
  },
  {
    id: 'ch5',
    label: 'Chapter 5',
    page: '9',
    chapterTitle: 'How the Ceremony Is Performed',
    content: [
      { type: 'chapter', number: 5, text: 'How the Ceremony Is Performed' },
      { type: 'body', text: 'Outdooring (Aba-Dinto) usually takes place at the father\'s family house on the eighth day after the child\'s birth.' },
      { type: 'body', text: 'Early that morning, two respected elders of good character from the father\'s family are sent to bring the mother and baby from the mother\'s family house. This symbolizes honor, family unity, and communal responsibility.' },
      { type: 'body', text: 'A respected elder is then chosen to lead the naming. Traditionally:' },
      { type: 'list', items: [
        'If the baby is a boy: the officiating elder is often a man.',
        'If the baby is a girl: the officiating elder is often a woman.',
      ]},
      { type: 'body', text: 'The ceremony begins with prayer and libation. A drink is poured by an elder who announces the occasion and its purpose. Blessings are called upon the child, the parents, the ancestors, and the community.' },
      { type: 'body', text: 'As guests arrive, the ceremony unfolds in a joyful and respectful spirit. The baby\'s name is publicly announced, and the family and guests respond with acceptance and celebration.' },
      { type: 'subheading', text: 'After the formal naming:' },
      { type: 'list', items: [
        'Food is served',
        'Guests present gifts',
        'Cash offerings may be given',
        'Music and dancing continue',
      ]},
      { type: 'body', text: 'The event closes with prayer, but the celebration often continues well into the day.' },
      { type: 'image', src: '/images/child dedication of parents wearing day borns white t shirt.webp', alt: 'Parents in day-born shirts at child dedication', caption: 'Parents honoring their roots — day-born shirts at the child\'s dedication.' },
      { type: 'image', src: '/images/all white day borns naming ceremony.webp', alt: 'All white day borns at naming ceremony', caption: 'Unity in white — day-born community gathered for the outdooring.' },
    ],
  },
  {
    id: 'ch6',
    label: 'Chapter 6',
    page: '11',
    chapterTitle: 'Teaching the Next Generation',
    content: [
      { type: 'chapter', number: 6, text: 'Teaching the Next Generation' },
      { type: 'body', text: 'Outdooring (Aba-Dinto) is more than a ceremony. It is also a teaching tradition.' },
      { type: 'body', text: 'Through this custom, children learn that identity begins with belonging. They learn that names carry meaning. They learn that family includes both maternal and paternal lines. They also learn that culture is something to be remembered, practiced, and passed on.' },
      { type: 'subheading', text: 'Lessons children can learn from Outdooring (Aba-Dinto)' },
      { type: 'list', items: [
        'Identity: A name connects a child to birth, family, and heritage.',
        'Belonging: A child is welcomed by both family and community.',
        'Respect: Elders play an important role in preserving tradition.',
        'Ancestry: The living remain connected to those who came before.',
        'Culture: Traditions survive when they are taught and practiced.',
      ]},
      { type: 'body', text: 'For readers in the diaspora, this tradition can become a bridge back to Ghanaian identity. Even if a person did not experience a formal ceremony as an infant, learning one\'s day name can still be a powerful act of reconnection.' },
      { type: 'image', src: '/images/ama & kwame t shirt.webp', alt: 'Ama and Kwame in day-born shirts', caption: 'Saturday-born Ama and Kwame — their names, their story, their shirts.' },
      { type: 'image', src: '/images/group of men and women wearing white t shirt day born.webp', alt: 'Group of day borns in white shirts', caption: 'A community of day borns — heritage worn, tradition celebrated.' },
    ],
  },
  {
    id: 'ch7',
    label: 'Chapter 7',
    page: '13',
    chapterTitle: 'It Is Not Too Late',
    content: [
      { type: 'chapter', number: 7, text: 'It Is Not Too Late' },
      { type: 'body', text: 'One of the most important truths about culture is this: what has been forgotten can still be remembered.' },
      { type: 'body', text: 'Many people were never formally introduced to Outdooring (Aba-Dinto). Some were not given the chance to know their Akan day name as children. Others grew up far away from Ghanaian customs and teachings.' },
      { type: 'quote', text: 'Yet it is not too late.' },
      { type: 'body', text: 'A person can still:' },
      { type: 'list', items: [
        'Learn the day of the week on which they were born',
        'Discover their Akan day name',
        'Teach their children and relatives',
        'Honor family lineage',
        'Restore a beautiful tradition in the home',
      ]},
      { type: 'body', text: 'To learn your name is to learn something about your place in the world. To reclaim that name is to reclaim a piece of your inheritance.' },
      { type: 'body', text: 'Outdooring (Aba-Dinto) reminds us that culture is not only what we receive. It is also what we choose to preserve and pass forward.' },
    ],
  },
  {
    id: 'author',
    label: 'Author Bio',
    page: '15',
    content: [
      { type: 'heading', text: 'About the Author' },
      { type: 'body', text: 'Afia, aka Mama Africa, is a mother, grandmother, retired healthcare professional, actress, and feminist with a deep love for culture, family, and storytelling.' },
      { type: 'body', text: 'When she is not writing, she enjoys reading food magazines, watching online cooking shows, and experimenting in the kitchen. A true food connoisseur, she delights in trying new recipes, preparing family favorites, and tasting cuisines from around the world.' },
      { type: 'body', text: 'She also enjoys travel, spa days, and peaceful walks in the park with her two dogs, Acorn and Pappy. One of her favorite pastimes is sitting on a park bench with her shades on, quietly people-watching and taking in the world around her.' },
      { type: 'body', text: 'Through her writing, Afia, aka Mama Africa, seeks to educate, uplift, and reconnect readers with culture, ancestry, and the beauty of African traditions.' },
    ],
  },
  {
    id: 'backcover',
    label: 'Back Cover',
    page: '16',
    content: [
      { type: 'heading', text: 'Back Cover' },
      { type: 'body', text: 'Outdooring (Aba-Dinto) is a warm and educational introduction to the Akan naming ceremony of Ghana.' },
      { type: 'body', text: 'Traditionally held on the eighth day after birth, Outdooring (Aba-Dinto) is the moment when a child is formally welcomed into the family and community and given a day name based on the day of the week on which the child was born. These names are more than personal identifiers. They are cultural, spiritual, and ancestral connections.' },
      { type: 'body', text: 'Written in simple and engaging language, this book is ideal for children, families, teachers, students, and anyone seeking to reconnect with Ghanaian heritage. Inside, readers will discover:' },
      { type: 'list', items: [
        'The meaning of Outdooring (Aba-Dinto)',
        'Why the ceremony takes place on the eighth day',
        'Akan day names for girls and boys',
        'A simple ceremony program outline',
        'Cultural lessons about identity, ancestry, and belonging',
      ]},
      { type: 'body', text: 'Whether you are learning this tradition for the first time or returning to it with renewed pride, this book offers a meaningful path back to your roots.' },
    ],
  },
];
